/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_History_RouteInputs */

const vi_vehicle_gps_history_route = /** @type {(inputs: Vehicle_Gps_History_RouteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di chuyển`)
};

/**

* @param {Vehicle_Gps_History_RouteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_history_route = /** @type {((inputs?: Vehicle_Gps_History_RouteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_History_RouteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_history_route(inputs)
});